<template>
  <v-row :justify="justifyCenter ? 'center' : null">
    <v-col sm="10" md="8">
      <v-card class="pa-3">
          <slot></slot>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'FhCard',
  props: {
    justifyCenter: Boolean
  },
}
</script>

<style scoped>

</style>
